export default "__VITE_ASSET__DFd8Pzm1__"